<template>
  <div id="People">
    <b-container fluid>
      <b-row>
        <b-col>
          <div class="title">Historical People</div>
        </b-col>
      </b-row>
      <b-row
        class="person_profile"
        :class="{ 'highlighted-person': isHighlighted(comp.id) }"
        v-for="(comp, i) in peopleComponent"
        :key="i"
        :id="comp.id"
      >
        <peopleprofile :person="comp"></peopleprofile>
      </b-row>
    </b-container>
    <comingsoon v-if="comingSoon == 0"></comingsoon>
  </div>
</template>

<script>
import storeTopic from "@/store/topic.js";
import peopleprofile from "@/components/PeopleProfile.vue";
import comingsoon from "./ComingSoon.vue";

export default {
  name: "People",
  components: { comingsoon, peopleprofile },
  data() {
    return {
      highlightedId: null,
      highlightTimer: null
    };
  },
  computed: {
    peopleComponent() {
      return storeTopic.state.people;
    },
    comingSoon() {
      return storeTopic.state.people.length;
    }
  },
  methods: {
    isHighlighted(id) {
      return Boolean(id && (this.highlightedId === id || this.$route.query?.scrollTo === id));
    },
    triggerHighlight(id) {
      if (!id) return;
      this.highlightedId = id;
      if (this.highlightTimer) {
        clearTimeout(this.highlightTimer);
      }
      this.highlightTimer = setTimeout(() => {
        this.highlightedId = null;
        this.highlightTimer = null;
      }, 4500);
    }
  },
  watch: {
    "$route.query.scrollTo": {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.triggerHighlight(newVal);
        }
      }
    }
  },
  mounted() {
    if (this.$route.query?.scrollTo) {
      this.triggerHighlight(this.$route.query.scrollTo);
    }
    storeTopic.dispatch("setTopicPeople", this.$route.params.topic);
    storeTopic.dispatch("setPeopleResources", this.$route.params.topic);
  },
  beforeUnmount() {
    if (this.highlightTimer) {
      clearTimeout(this.highlightTimer);
    }
  }
};
</script>

<style lang="sass" scoped src="@/assets/css/topicContent.sass"></style>
